import {AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {CdkDragMove} from '@angular/cdk/drag-drop';

const enum Status {
  OFF = 0,
  RESIZE = 1,
  MOVE = 2
}

@Component({
  selector: 'app-tdo-draggable-image',
  templateUrl: './tdo-draggable-image.component.html',
  styleUrls: ['./tdo-draggable-image.component.scss']
})
export class TdoDraggableImageComponent implements OnInit, AfterViewInit {
  @ViewChild('tdoImage') tdoImage: ElementRef;
  @ViewChild('box') box: ElementRef;

  @Input() imageSource = '';

  @Input() public width: number = 400;
  @Input() public height: number = 400;
  @Input() public index: number;
  @Input() public left: number;
  @Input() public top: number;
  @Input() public dragAreaColor: string = '#00000088';
  @Input() public minWidth: number = 40;

  @Input() public xStart: number = 0;
  @Input() public yStart: number = 0;

  @Input() scaleRate = 0.2;

  public status: Status = Status.OFF;

  imageSize = 100;
  scale = 1.0;
  mouseX = 0;
  mouseY = 0;

  originX = 0;
  originY = 0;

  private boxPosition: {left: number, top: number};
  private containerPosition: { left: number, top: number, right: number, bottom: number };

  public mouse: {x: number, y: number};
  private mouseClick: {x: number, y: number, left: number, top: number};

  @HostListener('window:mousemove', ['$event'])
  onMouseMoveMain(event: MouseEvent): void {
    this.mouse = { x: event.clientX, y: event.clientY };
    // console.log (this.mouse);
    if (this.status === Status.RESIZE) {
      this.resize();
    }
    // else if(this.status === Status.MOVE) this.move();
  }

  constructor(private elRef: ElementRef) {
    console.log('test');
    console.log(elRef.nativeElement.offsetLeft);
  }

  ngOnInit(): void {
    //
  }

  ngAfterViewInit(): void {
    //
    this.loadBox();
    this.loadContainer();
  }

  private loadBox(): void {
    const {left, top} = this.box.nativeElement.getBoundingClientRect();
    this.boxPosition = {left, top};
  }

  private loadContainer(): void {
    const left = this.boxPosition.left - this.left;
    const top = this.boxPosition.top - this.top;
    const right = left + 600;
    const bottom = top + 450;
    this.containerPosition = { left, top, right, bottom };
  }

  setStatus(event: MouseEvent, status: number): void {
    event.stopPropagation();
    if (status === 1) {
      event.stopPropagation();
    } else if (status === 2) {
      this.mouseClick = { x: event.clientX, y: event.clientY, left: this.left, top: this.top };
    } else {
      this.loadBox();
    }
    this.status = status;
  }

  private resize(): void{
    const originXPerc = this.originX / this.width;
    const originYPerc = this.originY / this.height;

    this.width = Number(this.mouse.x > this.boxPosition.left) ? this.mouse.x - this.boxPosition.left : 0;
    if (this.width < this.minWidth) {
      this.width = this.minWidth;
    }
    this.height = this.width;

    this.originX = this.width * originXPerc;
    this.originY = this.height * originYPerc;
  }

  private resizeCondMeet(): boolean {
    return (this.mouse.x < this.containerPosition.right && this.mouse.y < this.containerPosition.bottom);
  }

  onMouseWheel(event: any): void {
    this.originX = this.mouse.x - this.box.nativeElement.getBoundingClientRect().x;
    this.originY = this.mouse.y - this.box.nativeElement.getBoundingClientRect().y;

    if (event.deltaY > 0) {
      this.scale -= (this.scaleRate * this.scale);
    } else if (event.deltaY < 0) {
      this.scale += (this.scaleRate * this.scale);
    }

    if (this.scale < 1) {
      this.scale = 1;
    }
  }

  onMouseMove(event: MouseEvent): void {
    const screenX = event.screenX;
    const screenY = event.screenY;
    const clientX = event.clientX;
    const clientY = event.clientY;

    this.mouseX = clientX;
    this.mouseY = clientY;

    if (event.shiftKey) {
      this.originX = this.mouseX - this.box.nativeElement.getBoundingClientRect().x - 1;
      this.originY = this.mouseY - this.box.nativeElement.getBoundingClientRect().y - 1;
    }
  }

  reset(): void {
    this.scale = 1.0;
  }

  onDrag(event: CdkDragMove<HTMLDivElement>): void {
    this.left = this.box.nativeElement.getBoundingClientRect().x - 1;
    this.top = this.box.nativeElement.getBoundingClientRect().y - 1;
  }

  getImageDataUrl(): string {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    canvas.width = this.width;
    canvas.height = this.height;

    const rect = this.tdoImage.nativeElement.getBoundingClientRect();
    const rect2 = this.box.nativeElement.getBoundingClientRect();

    this.xStart = rect2.left - rect.left;
    this.yStart = rect2.top - rect.top;

    context.drawImage(this.tdoImage.nativeElement, -this.xStart, -this.yStart, rect.width, rect.height);

    return canvas.toDataURL('image/jpeg');
  }
}
